import { useReduxState } from "../../explorer/redux/hooks";
import { PartDetailsProps } from "../components/PartDetails/PartDetailsProps";
import { reduxStoreConfig } from "../configuration/reduxStoreConfig";

export const usePartDetails: () => {
    partDetailsProps: PartDetailsProps;
    openPartDetails: (partCode?: string, replacementCode?: string, manufacturer?: string, position?: string, parentNaturalKey?: string, navContext?: string, reloadBasket?: boolean) => void;
    closePartDetails: (reloadBasket?: boolean) => void;
} = () => {
    const [partDetailsProps, setPartDetailsProps] = useReduxState<PartDetailsProps>(reduxStoreConfig.sparePartsPartDetails);

    const openPartDetails = (partCode?: string, replacementCode?: string, manufacturer?: string, position?: string, parentNaturalKey?: string, navContext?: string, reloadBasket?: boolean) => {
        setPartDetailsProps({ open: true, partCode, replacementCode, manufacturer, position, parentNaturalKey, navContext, reloadBasket });
    };

    const closePartDetails = (reloadBasket: boolean = false) => {
        setPartDetailsProps({
            open: false,
            partCode: undefined,
            replacementCode: undefined,
            manufacturer: undefined,
            position: undefined,
            parentNaturalKey: undefined,
            navContext: undefined,
            reloadBasket: reloadBasket
        });
    };

    return { partDetailsProps, openPartDetails, closePartDetails };
};
